import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { ImageUpload } from 'containers/misc'
import { PersonEmail } from 'containers/forms/person'
import { Module } from 'components/misc'
import {
  Input,
  InputPhone,
  Select,
  InputDate,
  Textarea,
  Checkbox
} from 'components/fields'


export default class PersonalBlock extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    intlKey: PropTypes.string,
    titles: PropTypes.array,
    omitNote: PropTypes.bool,
    omitPhoto: PropTypes.bool,
    disablePhotoUpload: PropTypes.bool,
    disableEmail: PropTypes.bool,
    phoneTypes: PropTypes.array,
    data: PropTypes.object,
    formPrefix: PropTypes.string,
    change: PropTypes.func.isRequired,
    migratedEmail: PropTypes.string,
    decoPersonUpdate: PropTypes.string,
    canChangeEmail: PropTypes.bool,
    personId: PropTypes.number,
    personState: PropTypes.object,
    personHocConfig: PropTypes.object,
    hasMiddleName: PropTypes.bool,
    isOrganizationContact: PropTypes.bool,
    showTitle: PropTypes.bool,
    showSecondaryEmail: PropTypes.bool,
    showTertiaryEmail: PropTypes.bool,
    showMiddleName: PropTypes.bool,
    showPhone: PropTypes.bool,
    showPhoneType: PropTypes.bool,
    showDateOfBirth: PropTypes.bool
  }
  static defaultProps = {
    formPrefix: '',
    omitNote: false,
    omitPhoto: false,
    hasMiddleName: true,
    data: {},
    personState: {},
    isOrganizationContact: false,
    showTitle: true,
    showSecondaryEmail: true,
    showTertiaryEmail: true,
    showMiddleName: true,
    showPhone: true,
    showPhoneType: true
  }

  render() {
    const {
      titles,
      phoneTypes,
      change,
      data,
      formPrefix,
      omitNote,
      omitPhoto,
      title,
      intlKey,
      disableEmail,
      disablePhotoUpload,
      personHocConfig,
      migratedEmail,
      decoPersonUpdate,
      canChangeEmail,
      personId,
      personState,
      hasMiddleName,
      isOrganizationContact,
      showTitle,
      showSecondaryEmail,
      showTertiaryEmail,
      showMiddleName,
      showPhone,
      showPhoneType,
      showDateOfBirth
    } = this.props


    const narrowWrapperClass = omitPhoto ? 'col-xs-12' : 'col-xs-7'

    const narrowSelectClass = omitPhoto ? 'col-xs-3' : 'col-xs-12'

    const minAgeValue = get(data, 'person.minAgeValue') || get(data, 'minAgeValue')

    const dateOfBirth = get(data, 'person.birthDate') || get(data, 'birthDate')

    return (
      <Module title={title} intlKey={intlKey} narrow>
        <div className="row">
          {!omitPhoto &&
            <div className="col-xs-5">
              <ImageUpload
                change={change}
                photoUrl={get(data, 'photoUrl') || get(data, 'person.photoUrl')}
                formPrefix={formPrefix}
                disabled={disablePhotoUpload}
              />
            </div>}

          <div className={narrowWrapperClass}>
            <Module plain>
              <div className="row">
                {showTitle &&
                  <div className={narrowSelectClass}>
                    <Select
                      label="Title"
                      intlKey="label.title"
                      name={`${formPrefix}title`}
                      options={titles}
                    />
                  </div>}
              </div>

              <div className="row">
                <div className={hasMiddleName ? 'col-xs-6' : 'col-xs-12'}>
                  <Input
                    label="First name"
                    intlKey="label.first_name"
                    name={`${formPrefix}firstName`}
                  />
                </div>
                {showMiddleName &&
                  <div className="col-xs-6">
                    <Input
                      label="Middle name"
                      intlKey="label.middle_name"
                      name={`${formPrefix}middleName`}
                    />
                  </div>}
              </div>

              <div className="row">
                <div className="col-xs-12">
                  <Input
                    label="Last name"
                    intlKey="label.last_name"
                    name={`${formPrefix}lastName`}
                  />
                </div>
              </div>
            </Module>
          </div>
        </div>

        {!(showTitle || showMiddleName) && <br />}

        <div className="row">
          <div className="col-xs-12">
            <PersonEmail
              label="Email"
              intlKey="label.email"
              name={`${formPrefix}email`}
              disabled={disableEmail}
              personState={personState}
              migratedEmail={migratedEmail}
              decoPersonUpdate={decoPersonUpdate}
              canChangeEmail={canChangeEmail}
              personId={personId}
              personHocConfig={personHocConfig}
            />
          </div>
        </div>

        {showSecondaryEmail && <div className="row">
          <div className="col-xs-9">
            <Input
              label="Secondary email"
              intlKey="label.secondary_email"
              name={`${formPrefix}secondaryEmail`}
            />
          </div>
        </div>}

        {showTertiaryEmail && <div className="row">
          <div className="col-xs-9">
            <Input
              label="Tertiary email"
              intlKey="label.tertiary_email"
              name={`${formPrefix}tertiaryEmail`}
            />
          </div>
        </div>}

        {(showPhone || showPhoneType) && <div className="row">
          {showPhone && <div className="col-xs-6">
            <InputPhone
              label="Phone number"
              intlKey="label.phone_number"
              name={`${formPrefix}phone`}
            />
          </div>}

          {showPhoneType && <div className="col-xs-6">
            <Select
              label="Phone type"
              intlKey="label.phone_type"
              name={`${formPrefix}phoneType.value`}
              options={phoneTypes}
            />
          </div>}
        </div>}

        <div className="row">
          <div className="col-xs-6">
            <InputPhone
              label="Secondary phone number"
              intlKey="label.secondary_phone_number"
              name={`${formPrefix}secondaryPhone`}
            />
          </div>

          <div className="col-xs-6">
            <Select
              label="Secondary phone type"
              intlKey="label.secondary_phone_type"
              name={`${formPrefix}secondaryPhoneType.value`}
              options={phoneTypes}
            />
          </div>
        </div>

        {(!isOrganizationContact || (showDateOfBirth && dateOfBirth)) && <div className="row">
          <div className="col-xs-6">
            <InputDate
              label="Birthdate"
              intlKey="label.birthdate"
              name={`${formPrefix}birthDate`}
              allowFuture={false}
            />
          </div>
        </div>}
        {isOrganizationContact && minAgeValue && (!showDateOfBirth || !dateOfBirth) && <div className="row">
          <div className="col-xs-6">
            <Checkbox
              name="minAgeConfirmation"
              label="Person is older than {age}."
              intlKey="label.age_confirmed"
              intlValues={{
                age: (Math.round(minAgeValue / 12))
              }}
              disabled
              checked={minAgeValue}
            />
          </div>
        </div>}

        {!omitNote &&
          <div className="row">
            <div className="col-xs-12">
              <Textarea
                label="Note"
                intlKey="label.note"
                name={`${formPrefix}note`}
              />
            </div>
          </div>}
      </Module>
    )
  }
}
